const LoginImages = {
  leftContentImage: '/static/images/log-in-acuitis.jpg',
  bgImageColor: `rgba(124, 103, 80, 0.7)`,
};

export default LoginImages;
